import { createContext } from 'react';

const AuthContext = createContext({});
const BadgeContext = createContext({});
export { AuthContext, BadgeContext };
export { SelectedLabContext, SelectedLabProvider } from './selected-lab-context';